import styled from '@emotion/styled'
import AppCommandBar from 'app/AppCommandBar'
import { FlexSpinner } from 'components'
import { StickyPane } from 'components/StickyPane'
import { FormikActions } from 'formik'
import {
  CreateProvingForm,
  CreateProvingFormSchema,
} from 'forms/CreateProvingForm'
import { Box } from 'grid'
import { useAuthContext } from 'hooks/useAuthContext'
import { useCustomSearchCommand, useShowCommand } from 'hooks/useCommand'
import { useFormikPanelState } from 'hooks/useFormikPanelState'
import { useRouteParams } from 'hooks/useRouteParams'
import useSelection from 'hooks/useSelection'
import { uniq } from 'lodash-es'
import { Proving, ProvingInsertType } from 'model'
import { FormikPanel } from 'panels'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'react-router5'
import { useCreateProvingMutation } from 'views/ProvingsIndexView/ProvingsIndexView.generated'
import { useReadHomeQuery } from './HomeIndexView.generated'
import { TaskList } from './TaskList'

const Header = styled(Box)`
  font-weight: 600;
  font-size: 16px;
  padding: 15px 25px 10px 25px;
`

const HomeIndexListView: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const router = useRouter()

  const [panelState, , hidePanel] = useFormikPanelState<ProvingInsertType>()
  const auth = useAuthContext()
  const [routeParams, updateRouteParams] = useRouteParams<{
    search?: string
  }>('provings', {
    search: undefined,
  })
  const showProving = React.useCallback(
    (proving: Partial<Proving>) => {
      router.navigate('provings.details', { id: proving.id })
    },
    [router]
  )
  const showNewProving = React.useCallback(
    (proving: Partial<Proving>) => {
      router.navigate('provings.details', {
        id: proving.id,
        page: 'participants',
      })
    },
    [router]
  )
  const [selection, selectedItems] = useSelection<Partial<Proving>>({
    getKey: (item) => item!.id!,
  })

  // useCreateCommand('proving', {
  //   priority: 10,
  //   hidden: isExternal,
  //   onClick: () => showPanel({} as ProvingInsertType),
  // })

  useShowCommand(
    { name: 'proving', count: selectedItems.length },
    {
      priority: 20,
      onClick: () => showProving(selectedItems[0]),
    },
    [selectedItems]
  )

  useCustomSearchCommand(
    {
      value: routeParams.search,
      placeholder: t('model.proving.search'),
      onSearch: (value) => updateRouteParams({ search: value }),
      onClear: () => {
        updateRouteParams({ search: undefined })
      },
    },
    [routeParams, updateRouteParams]
  )

  const { loading, data, refetch, error } = useReadHomeQuery({
    variables: {
      search: routeParams.search,
    },
  })
  // const news =
  //   data && data.multinews ? data.multinews.filter(x => !x._deleted) : []

  // const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  // const columns = React.useMemo(
  //   () => [
  //     fieldColumn('title', {
  //       minWidth: 85,
  //       ungroupable: true,
  //       isSorted: true,
  //     }),
  //     fieldColumn('modified', {
  //       onRender: renderTimeAgo,
  //       ungroupable: true,
  //     }),
  //   ],
  //   [fieldColumn]
  // )

  const [createProving] = useCreateProvingMutation()
  const items =
    data && data.provings ? data.provings.filter((x) => !x._deleted) : []
  let myTodos: any[] = []
  if (auth.user) {
    // Erprobungsorganisation
    items.forEach((i) => {
      if (i.hasIncompleteBookings === true) {
        // tslint:disable-next-line: no-unused-expression
        i.editor &&
          i.editor.forEach((ed) => {
            if (ed.upn === auth.user!.upn) {
              myTodos.push(i)
            }
          })
      } else {
        if ([3, 7].includes(i.status)) {
          // tslint:disable-next-line: no-unused-expression
          i.editor &&
            i.editor.forEach((ed) => {
              if (ed.upn === auth.user!.upn) {
                myTodos.push(i)
              }
            })
        }
      }
    })
    // Clearing
    items.forEach((i) => {
      if ([2, 6].includes(i.status)) {
        // tslint:disable-next-line: no-unused-expression
        i.provingGround &&
          i.provingGround.clearing &&
          i.provingGround.clearing.forEach((c) => {
            if (c.upn === auth.user!.upn) {
              myTodos.push(i)
            }
          })
      }
    })
    // Service Team
    items.forEach((i) => {
      if (i.hasIncompleteBookings === true) {
        // tslint:disable-next-line: no-unused-expression
        i.provingGround &&
          i.provingGround.authorizedEditors &&
          i.provingGround.authorizedEditors.forEach((a) => {
            if (a.upn === auth.user!.upn) {
              myTodos.push(i)
            }
          })
      } else {
        if (
          [3, 7].includes(i.status) &&
          auth.user &&
          auth.user.roles![0] === 'HRG'
        ) {
          if (
            i._changes &&
            i._changes.changes &&
            i._changes.changes.find((c) =>
              c.change.path.includes('participants')
            )
          ) {
            // tslint:disable-next-line: no-unused-expression
            i.provingGround &&
              i.provingGround.authorizedEditors &&
              i.provingGround.authorizedEditors.forEach((a) => {
                if (a.upn === auth.user!.upn) {
                  myTodos.push(i)
                }
              })
          }
        } else if ([3, 7].includes(i.status)) {
          // tslint:disable-next-line: no-unused-expression
          i.provingGround &&
            i.provingGround.authorizedEditors &&
            i.provingGround.authorizedEditors.forEach((a) => {
              if (a.upn === auth.user!.upn) {
                myTodos.push(i)
              }
            })
        }
      }
    })
    // Ressourcenmanager
    items.forEach((i) => {
      if (i.hasIncompleteBookings === true) {
        // tslint:disable-next-line: no-unused-expression
        i.resourceManager &&
          i.resourceManager.forEach((res) => {
            if (res.upn === auth.user!.upn) {
              myTodos.push(i)
            }
          })
      } else {
        if ([3, 7].includes(i.status)) {
          // tslint:disable-next-line: no-unused-expression
          i.resourceManager &&
            i.resourceManager.forEach((res) => {
              if (res.upn === auth.user!.upn) {
                myTodos.push(i)
              }
            })
        }
      }
    })
    // Meister
    items.forEach((i) => {
      if ([3, 4, 5, 6, 7].includes(i.status)) {
        // tslint:disable-next-line: no-unused-expression
        i.maintenanceHead &&
          i.maintenanceHead.forEach((mh) => {
            if (mh.upn === auth.user!.upn) {
              myTodos.push(i)
            }
          })
      }
    })
    // Antragsteller
    items.forEach((i) => {
      if (
        i.createdBy.upn === auth.user!.upn &&
        [1, 4, 5, 10].includes(i.status)
      ) {
        myTodos.push(i)
      }
    })
    // Reisebüro Bearbeiter
    items.forEach((i) => {
      if (i.hrgEditor && i.hrgIsEditing) {
        if ((i.hrgEditor || []).some((edi) => edi.upn === auth.user!.upn)) {
          myTodos.push(i)
        }
      }
    })
  }

  myTodos = uniq(myTodos)

  const handleSubmit = async (
    values: ProvingInsertType,
    formikActions: FormikActions<ProvingInsertType>
  ) => {
    formikActions.setSubmitting(true)

    const createdProvingJSON = await createProving({
      variables: { input: values },
    })
    const newProvingJson = createdProvingJSON as unknown as {
      data: { createProving: { id: string } }
    }
    const newProving: Partial<Proving> = {
      id: newProvingJson.data.createProving.id,
    }
    await refetch({
      search: routeParams.search,
    })

    formikActions.setSubmitting(false)
    hidePanel()
    showNewProving(newProving)
  }

  return (
    <FlexSpinner loading={loading} error={error}>
      {/* <Header>{t('field.currentNews.label')}</Header>
      {news.length > 0 && (
        <div style={{ maxHeight: '176px', overflow: 'scroll' }}>
          <HoverCardList
            items={news}
            columns={columns}
            isHeaderVisible={false}
          />
        </div>
      )} */}

      {myTodos && (
        <>
          <Header>{t('field.mytodos.label')}</Header>
          <TaskList
            items={myTodos}
            onItemInvoked={showProving}
            selection={selection}
          />
        </>
      )}
      <FormikPanel
        {...panelState}
        onSubmit={handleSubmit}
        validationSchema={new CreateProvingFormSchema()}
        headerText={t('model.proving.create')}
      >
        <CreateProvingForm />
      </FormikPanel>
    </FlexSpinner>
  )
}

export const HomeIndexView: React.FC = () => (
  <>
    <StickyPane>
      <AppCommandBar />
      <HomeIndexListView />
    </StickyPane>
  </>
)
